import React from 'react';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { InputForm } from '../../../shared/components/form_components/input';

interface Props {
  periodo?: FormPeriodo;
  onSubmit: (periodo: FormPeriodo) => void;
  onCancel?: () => void;
}

interface FormPeriodo {
  id_periodo?: number;
  dsc_periodo: string;
  dat_inicio: string;
  dat_fim: string;
}

const FormularioPeriodo: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'id_periodo',
      label: 'Id período',
      type: 'number',
      defaultValue: props.periodo?.id_periodo,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'dsc_periodo',
      label: 'Descrição período',
      type: 'text',
      defaultValue: props.periodo?.dsc_periodo,
      required: true,
      component: InputForm,
    },
    {
      name: 'dat_inicio',
      label: 'Data início',
      type: 'date',
      defaultValue: props.periodo?.dat_inicio,
      required: true,
      component: InputForm,
    },
    {
      name: 'dat_fim',
      label: 'Data fim',
      type: 'date',
      defaultValue: props.periodo?.dat_fim,
      required: true,
      component: InputForm,
    },
  ];

  return (
    <Form
      fields={fields}
      form_name='período'
      is_edit={Boolean(props.periodo)}
      onSubmit={props.onSubmit}
      onCancel={props.onCancel}
    />
  );
};

export { FormularioPeriodo };
export type { FormPeriodo };
